define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'jump', 'lightbox'],
    function ($, transit, modernizr, container, preloader, jumpFactory, lightboxFactory) {

        return (function () {

            const name = 'module-about';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const jump = jumpFactory.create();
            const lightbox = lightboxFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {

            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                gameSize: {
                    width: 940,
                    height: 616
                },

                windowCurrentHeight: 0,

                gameInterval: ''
            };

            view.startup = function () {
                lightbox.init(view.publicVars.lightboxSetup);
                lightbox.setCloseCallback(view.methods.onLightboxClose);

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);

                if($(view.publicVars.cssId.aboutGameWrapperCls).length > 0) {
                    view.privateVars.windowCurrentHeight = $(view.publicVars.cssId.aboutHiddenDivHeightCls).outerHeight();

                    setInterval(function () {
                        const checkHeight = $(view.publicVars.cssId.aboutHiddenDivHeightCls).outerHeight();

                        if(checkHeight != view.privateVars.windowCurrentHeight) {
                            view.methods.calculateLightboxSize(view.privateVars.gameSize.width, view.privateVars.gameSize.height);
                        }
                    }, 100);
                }
            };

            view.bind = function () {
                $(view.publicVars.cssId.aboutGameWrapperCls).click(function () {
                    const src = container.getData($(view.publicVars.cssId.aboutLightboxGameIframeId)[0], 'src');

                    view.methods.handleGameClick(src);
                });

                $(window).on('resize', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gameSize.width, view.privateVars.gameSize.height);
                    }
                });

                $(window).on('orientationchange', (e) => {
                    if (lightbox.getStatus() === 1) {

                        var iframe = document.getElementById(view.publicVars.cssId.aboutLightboxGameIframeId.substr(1)).contentWindow;
                        iframe.postMessage({
                            orientation: e.target.screen.orientation.angle
                        }, view.publicVars.gameUrl);

                        view.methods.calculateLightboxSize(view.privateVars.gameSize.width, view.privateVars.gameSize.height);
                    }
                });


                $(window).on('touchmove', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gameSize.width, view.privateVars.gameSize.height);
                    }
                });
            };

            view.methods = {
                handleGameClick: (src) => {

                    container.trackInteraction('show game click', {
                        'subsection': 'series|about',
                        'contenttype': 'about',
                        'contenttitle': 'about game almost dj click'
                    });

                    $('html').addClass(view.publicVars.cssId.aboutLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.aboutLightboxLoaderId).css({ display: 'block'});

                    $(view.publicVars.cssId.aboutLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    view.methods.calculateLightboxSize(view.privateVars.gameSize.width, view.privateVars.gameSize.height);

                    lightbox.showLayer(() => {
                        $(view.publicVars.cssId.aboutLightboxGameIframeId).attr('src', src);

                        view.privateVars.gameInterval = setInterval(function () {
                            var iframe = document.getElementById(view.publicVars.cssId.aboutLightboxGameIframeId.substr(1)).contentWindow;
                            iframe.postMessage({
                                orientation_startup: window.orientation
                            }, view.publicVars.gameUrl);

                        }, 1000);


                        const state = container.getReduxStore().getState();

                        if(state.trailerPlayer) {
                            state.trailerPlayer.pause();
                        }

                        if(state.videoPlayerPlayer) {
                            state.videoPlayerPlayer.pause();
                        }

                        if(state.spotifyIframe) {
                            state.spotifyIframe.src = state.spotifyIframe.src;
                        }

                        setTimeout(function () {
                            $(view.publicVars.cssId.aboutLightboxLoaderId).transit({ opacity: 0}, () => {
                                $(view.publicVars.cssId.aboutLightboxLoaderId).css({ visibility: 'hidden'});

                                $(view.publicVars.cssId.aboutLightboxCls).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                                //view.privateVars.anim = 0;
                                $(view.publicVars.cssId.aboutLightboxGameIframeId).transit({ visibility: 'visible', opacity: 1 }, 500, () => {

                                });
                            });
                        }, 1000);

                    });
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(view.publicVars.cssId.aboutHiddenDivHeightCls).outerHeight();

                    view.privateVars.windowCurrentHeight = windowHeight;

                    const paddingTop = parseInt($(view.publicVars.cssId.aboutLightboxAreaCls).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.aboutLightboxAreaCls).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.aboutLightboxAreaCls).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.aboutLightboxAreaCls).css('padding-right'));

                    const border = parseInt($(view.publicVars.cssId.aboutLightboxAreaCls).css('border-width'));

                    const marginCloseTop = parseInt($(view.publicVars.cssId.aboutLightboxCloseWrapperId).css('top'));
                    const marginCloseRight = parseInt($(view.publicVars.cssId.aboutLightboxCloseWrapperId).css('right'));

                    const maxWidth = windowWidth - paddingLeft - paddingRight - border - border + marginCloseRight + marginCloseRight;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - border - border + marginCloseTop + marginCloseTop;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.gameSize.width;
                    let adjustedHeight = view.privateVars.gameSize.height;

                    if (width !== '' && height !== '' && parseInt(width) > 400 && parseInt(height) > 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + border + border;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + border + border;

                    $(view.publicVars.cssId.aboutLightboxAreaCls)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                },

                onLightboxClose: () => {
                    $('html').removeClass(view.publicVars.cssId.aboutLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.aboutLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    $(view.publicVars.cssId.aboutLightboxLoaderId).finish();
                    $(view.publicVars.cssId.aboutLightboxLoaderId).removeAttr('style');
                    $(view.publicVars.cssId.aboutLightboxLoaderId).css({ display: 'block'});

                    $(view.publicVars.cssId.aboutLightboxPlayerId).css({ opacity: 0});

                    $(view.publicVars.cssId.aboutLightboxGameIframeId).removeAttr('src');
                    $(view.publicVars.cssId.aboutLightboxGameIframeId).attr('src', '');

                    clearInterval(view.privateVars.gameInterval);

                    container.trackInteraction('show game close', {
                        'subsection': 'series|about',
                        'contenttype': 'about',
                        'contenttitle': 'about game almost dj close'
                    });
                },

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowCharacter', view.methods.actionShowCharacter);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
